import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1Aiml1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1umfaIIrzUcuPPtvaz6ndkbixCu4Saerc/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1lEMluEx7w4k9seJ_-is5wM1_LdzVV64c/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1_gWTXI5p3kHtmAQIIUnsRS_OXunDRPWz/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">AIML Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Aiml1;
